class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    this.mainDetailsToggle.addEventListener('click', this.onClick.bind(this), true);
    document.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  // Mouse only, so touch devices keep tap to open and tap to close.
  onPointerEnter(event) {
    if (event.pointerType !== 'mouse') return;
    this.hovering = true;
    clearTimeout(this.closeTimer);
    this.openTimer = setTimeout(() => this.open(), 100);
  }

  onPointerLeave(event) {
    if (event.pointerType !== 'mouse') return;
    this.hovering = false;
    clearTimeout(this.openTimer);
    this.closeTimer = setTimeout(() => this.close(), 200);
  }

  // Without this, a mouse click on an open menu closes it while the pointer is still over it.
  onClick(event) {
    if (!this.hovering || event.detail === 0) return;
    if (!this.mainDetailsToggle.open || !event.target.closest('summary')) return;
    event.preventDefault();
    event.stopPropagation();
  }

  // Keyboard focus inside the menu is left to the theme's own Escape handling.
  onKeyDown(event) {
    if (event.key !== 'Escape' || !this.hovering) return;
    if (!this.contains(document.activeElement)) this.close();
  }

  open() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }
}

customElements.define('header-menu', HeaderMenu);
